import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "from" }
const _hoisted_2 = { class: "distance" }
const _hoisted_3 = { class: "departure-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "hide-show-map-btn" }
const _hoisted_7 = { class: "gmap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_StyledSFSGoogleMap = _resolveComponent("StyledSFSGoogleMap")!

  return (_openBlock(), _createBlock(_component_StyledSFSGoogleMap, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_12), 1),
          _createVNode(_component_GMapAutocomplete, {
            class: "form-control mb-3",
            placeholder: _ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_20,
            value: _ctx.origin.display_address ? _ctx.origin.display_address : _ctx.origin_display_address,
            disabled: _ctx.origin.disabled ? _ctx.origin.disabled : _ctx.origin_disabled,
            onPlace_changed: _ctx.setOriginPlace
          }, null, 8, ["placeholder", "value", "disabled", "onPlace_changed"]),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_13) + " " + _toDisplayString(_ctx.distance.toFixed(1)) + " " + _toDisplayString(_ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_14), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_15), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_component_GMapAutocomplete, {
                key: _ctx.gmapKey,
                class: "form-control",
                placeholder: _ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_20,
                value: _ctx.destination.display_address ? _ctx.destination.display_address : _ctx.destination_display_address,
                disabled: _ctx.destination.disabled ? _ctx.destination.disabled : _ctx.destination_disabled,
                onPlace_changed: _ctx.setDestinationPlace,
                onBlur: _ctx.showAddressAgain
              }, null, 8, ["placeholder", "value", "disabled", "onPlace_changed", "onBlur"]))
            ])
          ]),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMap()))
          }, _toDisplayString(!_ctx.isShowMap ? _ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_16 : _ctx.groundHandlerMessage?.taxi.SFS_LANG_ROW_17), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_GMapMap, {
            ref: "map",
            style: {"width":"100%","height":"50vh"},
            zoom: 12,
            center: _ctx.center,
            "map-type-id": "terrain"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GMapMarker, { position: _ctx.center }, null, 8, ["position"])
            ]),
            _: 1
          }, 8, ["center"])
        ], 512), [
          [_vShow, _ctx.isShowMap]
        ])
      ])
    ]),
    _: 1
  }))
}